import React, { useEffect, useState } from "react";
import PlayBackTripHead from "./HistoryPlayBackTripHead/PlayBackTripHead";
import { useGetSpecificDeviceQuery } from "../../../Redux/service/Devices";
import PlayBackTripDate from "./HistoryPlayBackTripDate/PlayBackTripDate";
import PlayBackOptions from "./HistoryPlayBackOptions/PlayBackOptions";
import PlayBackFunctions from "./HistoryPlayBackFunctions/PlayBackFunctions";
import PlayBackTripDetails from "./HistoryPlayBackDetails/PlayBackTripDetails";
import { useGetEventReportQuery } from "../../../Redux/service/ReportEvents/ReportEvents";
import PlayBackEvents from "./HistoryPlayBackEvents/PlayBackEvents";
import PlayBackControls from "../HistoryPlay/PlayBackControls";
import { useParams } from "react-router-dom";

export default function PlayBackTrip({
	vid,
	setStartDate,
	startDate,
	setEndDate,
	endDate,
	HistoryPlayBack,
	mainhistorypositions,
	colors,
	setPlayBackSpeed,
	settings,
	setSettings,
	setMedia,
	setMinimizeAll,
	setMinimizeMediaPlayer,
	minimzeMediaPlayer,
	playAllHist,
	setPlayAllHist,
}) {
	const { id } = useParams();
	const finalId = vid || id;
	console.log("SADSAD", finalId);

	let { data: VehicleData } = useGetSpecificDeviceQuery(finalId, {
		skip: !finalId,
	});
	let { data: HistoryEvents } = useGetEventReportQuery(
		{
			from: startDate,
			to: endDate,
			selectedids: finalId,
		},
		{ skip: !startDate || !endDate || !finalId },
	);
	useEffect(() => {
		return () => setMedia(false);
	}, [setMedia]);
	console.log("History events", HistoryEvents);
	console.log("History VehicleData", VehicleData);
	/*let { data: DriverOfTrip } = useGetDriversByDeviceQuery(vid, { skip: !vid });
	let { data: GeofencesofDevice } = useGetGeofencesByDeviceQuery(vid, {
		skip: !vid,
	});*/
	const [select, setSelection] = useState("history");
	const lang = localStorage.getItem("lang") || "en";
	return (
		<div
			className="history-playback-trip p-0"
			style={{ right: lang === "ar" && "8px" }}
		>
			<PlayBackTripHead
				VehicleData={VehicleData?.length > 0 ? VehicleData[0] : ""}
				setMinimizeAll={setMinimizeAll}
				setMedia={setMedia}
				setPlayAllHist={setPlayAllHist}
			/>
			<div className="H-line"></div>
			<PlayBackTripDate
				setStartDate={setStartDate}
				startDate={startDate}
				setEndDate={setEndDate}
				endDate={endDate}
				vid={vid}
			/>
			<div className="H-line"></div>
			<PlayBackOptions setSelection={setSelection} select={select} />
			<div className="d-flex">
				<div
					className={select === "history" ? "active-line" : "H-line-50"}
				></div>
				<div
					className={select === "events" ? "active-line" : "H-line-50"}
				></div>
			</div>
			{select === "history" && (
				<>
					<PlayBackFunctions
						setPlayAllHist={setPlayAllHist}
						mainhistorypositions={mainhistorypositions}
						setSettings={setSettings}
						settings={settings}
					/>
					<div className="H-line"></div>
					<PlayBackTripDetails
						HistoryPlayBack={HistoryPlayBack}
						data={mainhistorypositions}
						colors={colors}
					/>
				</>
			)}
			{select === "events" && (
				<>
					<PlayBackEvents events={HistoryEvents} data={mainhistorypositions} />
				</>
			)}
		</div>
	);
}
